import { Component, input, OnChanges, OnInit, signal } from "@angular/core";
import { SafeHtml } from "@angular/platform-browser";
import { NgStyle } from "@angular/common";

@Component({
  selector: "sxw-svg-icon",
  templateUrl: "./svg-icon.component.html",
  styleUrls: ["./svg-icon.component.scss"],
  imports: [NgStyle],
  // use these vars for control the elements from outside in hover, active, media queries, etc.
  host: {
    "[style.--fill-color]": "fillColor()",
    "[style.--stroke-color]": "strokeColor()",
    "[style.--svg-width]": "width()+'px'",
    "[style.--svg-height]": "height()+'px'",
  },
})
export class SvgIconComponent implements OnInit, OnChanges {
  name = input<string | null>();
  fillColor = input<string | null | undefined, string | null | undefined>(null, {
    transform: (value: string | null | undefined) => value || "#000",
  });
  strokeColor = input<string | null | undefined, string | null | undefined>(null, {
    transform: (value: string | null | undefined) => value || "#000",
  });
  strokeWidth = input<string | null | undefined>(null);
  width = input<string | null | undefined, string | null | undefined>("20", {
    transform: value => value || "20",
  });
  height = input<string | null | undefined, string | null | undefined>("20", {
    transform: value => value || "20",
  });
  ngStyle = input<Record<string, string | number>>({
    display: "flex",
    width: "fit-content",
    height: "fit-content",
  });

  svgIcon = signal<string | SafeHtml>("");

  ngOnInit(): void {
    this.initSvgIcon();
  }

  ngOnChanges(): void {
    this.initSvgIcon();
  }

  private initSvgIcon(): void {
    if (!this.name()) {
      this.svgIcon.set("");
      return;
    }
    /**
     * This string represents the path to the svg and the last segment represents the id of the selected svg
     * Please note that when adding a new svg we need to set id attribute on the svg element
     */
    this.svgIcon.set(`/images/icons/${this.name()}.svg#${this.name()}`);
  }
}
